import {
  GET_RECURRING_PAYMENTS_LIST_FAILED,
  GET_RECURRING_PAYMENTS_LIST_SUCCESS,
  GET_RECURRING_PAYMENTS_LIST_LOADING,
  REMOVE_RECURRING_PAYMENTS_LIST,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  paymentsList: null,
  totalItems: 0,
};

export const recurringPaymentsListReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_RECURRING_PAYMENTS_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_RECURRING_PAYMENTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentsList: action.payload,
        totalItems:
          action.payload?.totalItems ||
          action.payload?.total ||
          action.payload?.totalElements ||
          (Array.isArray(action.payload?.data)
            ? action.payload.data.length
            : Array.isArray(action.payload)
            ? action.payload.length
            : 0),
        error: null,
      };
    case GET_RECURRING_PAYMENTS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        paymentsList: null,
        totalItems: 0,
        error: action.error,
      };
    case REMOVE_RECURRING_PAYMENTS_LIST:
      return initialState;
    default:
      return state;
  }
};




